import { render, staticRenderFns } from "./IdiomCoupon.vue?vue&type=template&id=960432be&scoped=true&"
import script from "./IdiomCoupon.vue?vue&type=script&lang=js&"
export * from "./IdiomCoupon.vue?vue&type=script&lang=js&"
import style0 from "./IdiomCoupon.vue?vue&type=style&index=0&id=960432be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960432be",
  null
  
)

export default component.exports